import { NgModule } from '@angular/core';
import { addNavMenuItem, SharedModule } from '@vendure/admin-ui/core';

@NgModule({
    imports: [SharedModule],
    providers: [
        addNavMenuItem(
            {
                id: 'active-clients-dashboard',
                label: 'Clientes Ativos',
                routerLink: ['/extensions/dashboard/active-clients'],
                icon: 'users',
            },
            'marketing'
        ),
    ],
})
export class ActiveClientsDashboardNavModule {}
